import axios from 'axios';

export class CloseSystemService {
    isCloseSystem(){
        return axios.get('/appapv/isClosedSystem.action', {
            headers: {
                'Content-Type': 'application/json',
            }
        }).then(res => res.data);
    }
}